import clsx from "clsx";
import { isEmpty, orderBy } from "lodash";
import { TMainPageLayoutV3 } from "../type";
import TClientMainPageItemList from "@/cms/types/TClientMainPageItemList";
import { outerNameDescriptionLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
import RMDRLink from "@/components/RMDRLink";


type TRenderButton = {

    template:TClientMainPageItemList;
    isPrev?:boolean;
    isNext?:boolean;
}

type TRenderButtons = {

    childs?:TClientMainPageItemList[];

}

const RenderButton = ( props:TRenderButton ) => {
    const languageVersion = outerNameDescriptionLanguageVersion(props.template.languageVersions);

    if ( !props.template.hasDestinationNavigation ) return <div></div>;

    return (
        <RMDRLink
            title={languageVersion?.name}
            hasNavigationDestination={props.template.hasDestinationNavigation}
            navigationURL={languageVersion?.contentRouteNavigationURL}
            redirectType={props.template.redirectType}
            isShowAlways={true}
            className="theme-btn"
            extraData={{
                "data-aos-duration":"800",
                "data-aos":"fade-up",
                "data-aos-delay":"700"
            }}
        >
            {props.isPrev && <i className="fa-solid fa-arrow-left-long btn-prev"></i>}
            {languageVersion?.name}
            {props.isNext && <i className="fa-solid fa-arrow-right-long btn-next"></i>}
        </RMDRLink>
    )
}

const RenderButtons = ( props:TRenderButtons ) => {

    if ( !props.childs || isEmpty(props.childs)) return null;

    return (
        <div className="hero-button justify-content-between">
            {
                props.childs.map((item, index) => {
                    return <RenderButton template={item} isPrev={index===0} isNext={index===1} />
                })
            }
        </div>
    )
}

const MNPG035 = ( props: TMainPageLayoutV3 ) => {
    console.log("MNPG035.rendered: ", props);

    if ( !props.template || isEmpty(props.template) || !props.templates || isEmpty(props.templates) ) return null;

    const childs = orderBy(props.templates.filter((item) => item.parentId === props.template?.id), ["order"], ["asc"]);

    return (
        <section className={clsx("section", {"section-padding":props._layoutType}, {"section-padding-3":!props._layoutType})}>
            <div className="container">
                <RenderButtons childs={childs} />
            </div>
        </section>
    )
}

export default MNPG035;
